import { collection, deleteDoc, doc, onSnapshot, query } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from '../firebase';

const ShowToppers = () => {
    const [list, setList] = useState([]);

    useEffect(()=>{
     const q = query(collection(db, "toperStudents"));
      onSnapshot(q, (querySnapshot) => {
     let filesArry = [];
     querySnapshot.forEach((doc) => {
       filesArry.push({id:doc.id,...doc.data()});
     });
     setList(filesArry);
   });
    },[])
   
   
    const deleteField=async(tid)=>{
     await deleteDoc(doc(db, "toperStudents", tid));
       console.log("Deleted ===>" + tid);
       }
   
   
    // console.log(list[0]?.pictureUrl);
     return (
       <div className="justify-center pt-8">    
            <table className="w-full border text-center">
           <thead className="border-b ">
             <tr className="bg-gray-100">
               <th className="py-3"> Sl No.</th>
             <th>Files</th>
             <th>Name</th>
             <th>Percentage</th>
             <th>Delete</th>
           </tr>
         </thead>
         <tbody>
          {list?.map((item,index)=>(
           <tr className="border-b" key={index}>
           <td className="border-r">{++index}</td>
           <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r"><img src={item.pictureUrl} alt="pic" className="w-20 h-20"/></td>
           <td className="border-r">{item.studentName}</td>
           <td className="border-r">{item.studentPercentage}</td>
           <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
              <button className="text-white bg-red-600 py-2 px-4 rounded-md " onClick={()=>deleteField(item.id)}>Delete</button>
               </td>
           </tr>
        ))}
         </tbody>
        </table>
       </div>
     )
   }

export default ShowToppers